export enum EShortcutGroup {
  GENERAL = 'general',
  COLLECTIONS = 'collections',
  GENERATION = 'generation',
  GRID2D_BAR = 'grid2d_bar',
  GRID2D_CELL = 'grid2d_cell',
  GRID2D = 'grid2d',
  INPUT = 'input',
  NAVIGATION = 'navigation',
  FULLSCREEN_GRID2D = 'fullscreen_grid2d',
  FULLSCREEN_GRID2D_IMAGE = 'fullscreen_grid2d_image',
  FULLSCREEN_IMAGE_CANVAS = 'fullscreen_image_canvas',
  SLIDER = 'slider',
  USER_TASK = 'user_task',
}
